export default __webpack_public_path__ + "static/media/git.7d2439e8.svg";